import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppSelector } from 'store';

import { $apiV2, errorHandler, globalConst } from 'modules/global';

export const useVerifySms = () => {
  const queryClient = useQueryClient();
  const { replace } = useRouter();
  const redirectUrl = useAppSelector(({ authModal }) => authModal.redirectUrl);
  const ticketId = useAppSelector(({ authModal }) => authModal.ticketId);

  return useMutation({
    mutationFn: async ({ code, phone, platform }: { phone: string; code: string; platform?: string }) => {
      const { data } = await $apiV2.post('/auth/verify-sms', { phone, code, platform });

      return data;
    },
    onSuccess: async data => {
      await queryClient.invalidateQueries({ queryKey: [globalConst.queryKeys.USER_DATA] });
      if (data?.data?.profile_type !== null && redirectUrl) {
        return replace(redirectUrl);
      }

      if (data?.data?.profile_type !== null && ticketId) {
        return replace(`${globalConst.pageNames.RESULTS}/${ticketId}`);
      }

      return undefined;
    },
    onError: errorHandler()
  });
};
